import { blogs } from "../data/blogs.data";
import BlogCard from "./BlogCard";

export default function BlogRecommended({ currentSlug }) {
  const recommended = blogs.filter((b) => b.slug !== currentSlug).slice(0, 3);

  return (
    <section className="oglitz-blog-recommended">
      <h2>Recommended Articles</h2>
      <div className="oglitz-blog-recommended__grid">
        {recommended.map((blog) => (
          <BlogCard key={blog.slug} blog={blog} />
        ))}
      </div>
    </section>
  );
}
